var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('h2',{staticClass:"subTitle"},[_vm._v(_vm._s(_vm.subTitle))]),_c('h3',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }